export const taxonomies = {
  regions: ['Africa', 'Middle East', 'South Asia', 'Southeast Asia', 'Global'],
  sectors: ['WASH', 'Education', 'Healthcare', 'Emergency Relief', 'Livelihoods'],
  years: ['2024', '2023', '2022', '2021']
};

export const reports = [
  {
    id: 'rep-001',
    title: 'Clean Water Initiative: Rift Valley',
    region: 'Africa',
    sector: 'WASH',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&q=80&w=1600',
    summary: 'Establishing sustainable water infrastructure for remote communities, reducing waterborne diseases by 60%.',
    metrics: {
      beneficiaries: 45000,
      budget: 850000,
      locations: 12
    },
    countries: [
      'Kenya (Baringo)', 'Kenya (Nakuru)', 'Kenya (Narok)', 'Kenya (Kajiado)', 
      'Kenya (Kericho)', 'Kenya (Bomet)', 'Ethiopia (Oromia)', 'Ethiopia (Sidama)',
      'Tanzania (Arusha)', 'Tanzania (Manyara)', 'Uganda (Karamoja)', 'Uganda (Teso)'
    ],
    demographics: {
      children: 45,
      women: 35,
      men: 20
    },
    itemsDelivered: [
      { name: 'Solar Water Wells', count: 12, icon: 'FiSun' },
      { name: 'Filtration Systems', count: 450, icon: 'FiFilter' },
      { name: 'Hygiene Kits', count: 15000, icon: 'FiPackage' }
    ],
    milestones: [
      { date: 'Q1 2023', title: 'Community Assessment & Planning', description: 'Engaged local leaders to identify optimal well sites.' },
      { date: 'Q2 2023', title: 'Infrastructure Drilling', description: 'Completed drilling for all 12 primary solar wells.' },
      { date: 'Q4 2023', title: 'Handover & Training', description: 'Trained local committees on maintenance and hygiene.' }
    ],
    testimonial: {
      quote: "Before the well, my daughters walked 4 hours daily for water. Now they are in school, and our community is healthy.",
      author: "Amina J.",
      role: "Community Leader, Kenya",
      image: "https://images.unsplash.com/photo-1531123897727-8f129e1bfa8ea?auto=format&fit=crop&w=400&q=80"
    },
    fieldReports: [
      { type: 'video', url: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=80', title: 'Raw Distribution Footage' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1538300266-9ab3014a51e6?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1504712598893-24159a89200e?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1516905041604-a527f4d22181?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1544465544-1b71aee9dfa3?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1519751138087-5bf79df62d5b?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  {
    id: 'rep-002',
    title: 'Emergency Medical Support',
    region: 'Middle East',
    sector: 'Healthcare',
    year: '2024',
    image: 'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&q=80&w=1600',
    summary: 'Deploying mobile clinics and critical medical supplies to conflict-affected zones.',
    metrics: {
      beneficiaries: 120000,
      budget: 2100000,
      locations: 5
    },
    countries: ['Gaza (North)', 'Gaza (Khan Yunis)', 'West Bank', 'Lebanon (Bekaa)', 'Syria (Idlib)'],
    demographics: {
      children: 30,
      women: 40,
      men: 30
    },
    itemsDelivered: [
      { name: 'Mobile Clinics Deployed', count: 5, icon: 'FiTruck' },
      { name: 'Trauma Kits', count: 2000, icon: 'FiBriefcase' },
      { name: 'Surgeries Performed', count: 850, icon: 'FiActivity' }
    ],
    milestones: [
      { date: 'Jan 2024', title: 'Rapid Deployment', description: 'First mobile clinic operational within 48 hours.' },
      { date: 'Mar 2024', title: 'Supply Chain Established', description: 'Secured continuous flow of essential medicines.' },
      { date: 'Ongoing', title: 'Specialized Care', description: 'Providing pediatric and trauma surgery.' }
    ],
    testimonial: {
      quote: "The mobile clinic arrived when we had no other options. They saved my son's life.",
      author: "Tariq M.",
      role: "Father, Gaza",
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=400&q=80"
    },
    fieldReports: [
      { type: 'video', url: 'https://images.unsplash.com/photo-1516841273335-e39b37888115?auto=format&fit=crop&w=1200&q=80', title: 'Clinic Operations Footage' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1581056771107-24ca5f033842?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1551076805-e16760c26446?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  {
    id: 'rep-003',
    title: 'Girls Education Access Program',
    region: 'South Asia',
    sector: 'Education',
    year: '2023',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=1600',
    summary: 'Building schools and providing scholarships to ensure girls complete secondary education.',
    metrics: {
      beneficiaries: 8500,
      budget: 600000,
      locations: 24
    },
    countries: [
      'Uttar Pradesh', 'Bihar', 'Rajasthan', 'Madhya Pradesh', 'West Bengal', 'Jharkhand',
      'Odisha', 'Chhattisgarh', 'Punjab', 'Haryana', 'Maharashtra', 'Gujarat',
      'Karnataka', 'Tamil Nadu', 'Andhra Pradesh', 'Telangana', 'Kerala', 'Assam',
      'Manipur', 'Meghalaya', 'Tripura', 'Nagaland', 'Sikkim', 'Arunachal Pradesh'
    ],
    demographics: {
      children: 90,
      women: 10,
      men: 0
    },
    itemsDelivered: [
      { name: 'Schools Constructed', count: 4, icon: 'FiHome' },
      { name: 'Scholarships Awarded', count: 2500, icon: 'FiAward' },
      { name: 'Teachers Trained', count: 120, icon: 'FiUsers' }
    ],
    milestones: [
      { date: 'Feb 2023', title: 'Scholarship Distribution', description: 'Awarded grants to 2,500 at-risk girls.' },
      { date: 'Aug 2023', title: 'School Openings', description: 'Inaugurated 4 new secondary schools.' },
      { date: 'Dec 2023', title: 'Year-End Assessment', description: 'Recorded a 95% retention rate among scholars.' }
    ],
    testimonial: {
      quote: "I am the first in my family to attend high school. I want to become a doctor and help my village.",
      author: "Priya S.",
      role: "Student, Rural India",
      image: "https://images.unsplash.com/photo-1517365830460-955ce3ccd263?auto=format&fit=crop&w=400&q=80"
    },
    fieldReports: [
      { type: 'video', url: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1200&q=80', title: 'School Inauguration' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1511629091441-ee46146481b6?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  {
    id: 'rep-004',
    title: 'Sustainable Agriculture Initiative',
    region: 'Southeast Asia',
    sector: 'Livelihoods',
    year: '2022',
    image: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?auto=format&fit=crop&q=80&w=1600',
    summary: 'Empowering smallholder farmers with climate-resilient seeds and modern irrigation techniques.',
    metrics: {
      beneficiaries: 15000,
      budget: 450000,
      locations: 8
    },
    countries: ['Indonesia (Java)', 'Indonesia (Sumatra)', 'Vietnam (Mekong)', 'Thailand (Isan)', 'Cambodia (Siem Reap)', 'Laos (Vientiane)', 'Philippines (Luzon)', 'Myanmar (Shan)'],
    demographics: {
      children: 10,
      women: 45,
      men: 45
    },
    itemsDelivered: [
      { name: 'Seed Packets', count: 30000, icon: 'FiPackage' },
      { name: 'Irrigation Systems', count: 150, icon: 'FiDroplet' },
      { name: 'Farming Tools', count: 5000, icon: 'FiTool' }
    ],
    milestones: [
      { date: 'Mar 2022', title: 'Seed Distribution', description: 'Delivered climate-resilient seeds before planting season.' },
      { date: 'Jun 2022', title: 'Irrigation Setup', description: 'Installed drip irrigation in key communal farms.' },
      { date: 'Nov 2022', title: 'Harvest Festival', description: 'Celebrated a 40% increase in crop yield.' }
    ],
    testimonial: {
      quote: "The new seeds and irrigation have doubled our harvest. We can finally sell the surplus at the market.",
      author: "Budi W.",
      role: "Farmer, Indonesia",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80"
    },
    fieldReports: [
      { type: 'video', url: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?auto=format&fit=crop&w=1200&q=80', title: 'Harvest Documentation' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1505471768190-275e2ad7b3f9?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?auto=format&fit=crop&w=600&q=80' },
      { type: 'image', url: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?auto=format&fit=crop&w=600&q=80' }
    ]
  }
];